import { Fragment } from 'react';

import Views from '../AthleteUserViews';
import ViewTemplate from '../../../../components/viewTemplateOmeAthleteEntry/ViewTemplate';

import useAthleteUserEntriesIndividualOverride from './UseAthleteUserEntriesIndividualOverride';

import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import TimeInput from '@usas/ui-web/components/inputs/TimeInput';
import DatePicker from '@usas/ui-web/components/datepickers/DatePicker';
import EventMeetEventDropdown from '../../../../components/dropdowns/EventMeetEventDropdown';
import Input from '@usas/ui-web/components/inputs/Input';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

import Constants from '@usas/ui-web/utils/Constants';

const AthleteUserEntriesIndividualOverride = () => {
  const { eventMeetEventState, state, orgUnitAthleteEntryIndividualRosterEntryState, omeMeetOrgUnitAthleteEntryIndividualRosterEntryState,
    onSaveClicked, onBackClicked, onValueTextPairChanged, onFormValueChanged, formState, errorState
  } = useAthleteUserEntriesIndividualOverride();

  return (
    <Fragment>
      <ViewTemplate
        viewName={Views.OME_MEET_ROSTER_ENTRIES_INDIVIDUAL_OVERRIDE}
        onNextButtonClicked={onSaveClicked}
        onBackButtonClicked={onBackClicked}
        errorMessage={errorState.general}>
        <div className="row">
          <div className="col-xs-12 usas-extra-bottom-margin">
            <p className={global.HeaderText}><b>Individual Event:</b> {state.event?.eventName || ''} ({state.event?.eventCompetitionGenderTypeName || ''}, {state.event?.ageGroupName || ''}), Session {state.event?.meetSessionName || ''}</p>
            {formState.hasQualifyingWindow === true && <p className={global.HeaderText}><b>Qualifying Date Range:</b> {`${formState.qualifyingStartDate} - ${formState.qualifyingEndDate}`}</p>}
          </div>
        </div>
        <form>
          <div className='row'>
            <div className="col-xs-12 col-sm-6 col-md-4">
              <TimeInput
                label="Swim Time*"
                name="swimTime"
                value={formState.swimTime}
                error={errorState.swimTime}
                message={errorState.swimTime}
                onChange={(displayValue, value) => { onValueTextPairChanged(displayValue, 'swimTime', value, 'swimTimeValue'); }} />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-4">
              <EventMeetEventDropdown
                label="Event*"
                name="eventId"
                value={formState.eventId}
                error={errorState.eventId}
                message={errorState.eventId}
                onChange={(value, newValueLabel, e) => {
                  e && e.target && e.target.value &&
                    onValueTextPairChanged(value, 'eventId', newValueLabel, 'eventName')
                }}
                meetEventId={state.event?.meetEventId}
              />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-4">
              <DatePicker
                label="Swim Date*"
                name="swimDate"
                value={formState.swimDate}
                error={errorState.swimDate}
                message={errorState.swimDate}
                onChange={(value) => { onFormValueChanged('swimDate', value); }} />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-4">
              <Input
                label={formState.usasHostOrg === true ? formState.usasLsc === true ? "Meet Name* (Do not include Year or LSC)" : "Meet Name* (Do not include Year)" : "Meet Name*"}
                name="meetName"
                value={formState.meetName}
                error={errorState.meetName}
                message={errorState.meetName}
                onChange={(value) => { onFormValueChanged('meetName', value) }} />
            </div>
          </div>
        </form>
        <PopUpModal
          widthPct={30}
          maxWidth={250}
          title={Constants.LOADING_MSG}
          displayPopUp={orgUnitAthleteEntryIndividualRosterEntryState.isArrayLoading ||
            omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.isArrayLoading || eventMeetEventState.isArrayLoading} />
        <PopUpModal
          widthPct={30}
          maxWidth={250}
          title={Constants.SAVING_MSG}
          displayPopUp={orgUnitAthleteEntryIndividualRosterEntryState.isSaving} />
      </ViewTemplate>
    </Fragment >
  );
};

export default AthleteUserEntriesIndividualOverride;